class FileValidator {
  MAX_NUM_OF_FILES = 6;

  MAX_FILE_SIZE = 4e6; // Approximately 4.000.000 bytes, 4 MB

  ALLOWED_EXTENTIONS = /^image\/(jpe?g|a?png|gif)/i;

  defaults = {
    errorMessage: {
      maxNumOfFiles: `Total of ${this.MAX_NUM_OF_FILES} files can be uploaded at once.`,
      prohibitedExtentions: 'Only jpg, jpeg, png and gif file types can be uploaded.'
    },
    maxNumOfFiles: this.MAX_NUM_OF_FILES,
    maxFileSize: this.MAX_FILE_SIZE,
    allowedExtentions: this.ALLOWED_EXTENTIONS
  };

  errorCode = {
    maxNumOfFiles: 'TOO_MANY_FILES',
    prohibitedExtentions: 'DISALLOWED_FILE_EXTENTION',
    maxFileSize: 'TOO_BIG_FILE'
  };

  constructor(options) {
    this.settings = { ...this.defaults, ...options };

    this.settings.errorMessage.maxFileSize = `Only the files less than ${
      this.settings.maxFileSize / 1e6
    } MB can be uploaded.`;
  }

  validateFilesCount(filesCount) {
    console.log('');
    if (filesCount >= this.settings.maxNumOfFiles) {
      return {
        valid: false,
        errorCode: this.errorCode.maxNumOfFiles,
        readable: this.settings.errorMessage.maxNumOfFiles
      };
    }

    return { valid: true, errorCode: null, readable: null };
  }

  validateFileType(contentType) {
    if (!contentType.match(this.settings.allowedExtentions)) {
      return {
        valid: false,
        errorCode: this.errorCode.prohibitedExtentions,
        readable: this.settings.errorMessage.prohibitedExtentions
      };
    }

    return { valid: true, errorCode: null, readable: null };
  }

  validateFileSize(fileSize) {
    if (fileSize > this.settings.maxFileSize) {
      return {
        valid: false,
        errorCode: this.errorCode.maxFileSize,
        readable: this.settings.errorMessage.maxFileSize
      };
    }

    return { valid: true, errorCode: null, readable: null };
  }

  applyAllValidations(filesCount, contentType, fileSize) {
    const filesCountResult = this.validateFilesCount(filesCount);
    const fileTypeResult = this.validateFileType(contentType);
    const fileSizeResult = this.validateFileSize(fileSize);

    if (!filesCountResult.valid) return filesCountResult;
    if (!fileTypeResult.valid) return fileTypeResult;
    if (!fileSizeResult.valid) return fileSizeResult;

    return { valid: true, errorCode: null, readable: null };
  }
}

export default FileValidator;
